import { Controller } from 'stimulus';

export default class ShareLink extends Controller {
  open() {
    event.preventDefault();
    window.open(event.target.href, "", "height=500, width=700");
  }
}
